import { render, staticRenderFns } from "./AxDownItem.vue?vue&type=template&id=4a417ef4&scoped=true&"
import script from "./AxDownItem.vue?vue&type=script&lang=js&"
export * from "./AxDownItem.vue?vue&type=script&lang=js&"
import style0 from "./AxDownItem.vue?vue&type=style&index=0&id=4a417ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a417ef4",
  null
  
)

export default component.exports